export default __webpack_public_path__ + "static/media/zip.df1bda46.svg";